import { render, staticRenderFns } from "./OFFormInput.vue?vue&type=template&id=ddca40e4&scoped=true"
import script from "./OFFormInput.vue?vue&type=script&lang=js"
export * from "./OFFormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddca40e4",
  null
  
)

export default component.exports